import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMinusCircle = () => {
  return (
    <g>
      <path d="m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.9794 7.9794 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4781 6.4781 0 0 1 -6.4707 6.47z" />
      <path d="m11.3569 7.25h-6.7133a.75.75 0 0 0 0 1.5h6.7134a.75.75 0 1 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconMinusCircle);
